/** Which standard the Standard tool has selected. */

import { type SelectedLeg, selectionState } from "./selection.state.ts";

export function setSelectedLeg(leg: SelectedLeg | null): void {
  selectionState.set({ leg });
}
